import { BUSINESS } from "@/data/business";
import { CANONICAL_DOMAIN } from "@/data/cities";
import { TESTIMONIALS, REVIEW_RATING, VERIFIED_SOCIALS } from "@/data/business";

const ORG = {
  "@type": ["LocalBusiness", "HomeAndConstructionBusiness"],
  additionalType: "https://en.wikipedia.org/wiki/Garage_door",
  name: BUSINESS.name,
  image: [
    `${CANONICAL_DOMAIN}/og-image.jpg`,
    `${CANONICAL_DOMAIN}/images/work/modern-residential-garage-door-prosper-tx.jpg`,
    `${CANONICAL_DOMAIN}/images/work/new-garage-door-installation-prosper-tx.jpg`,
  ],
  logo: `${CANONICAL_DOMAIN}/logo.png`,
  telephone: BUSINESS.phoneRaw,
  email: BUSINESS.email,
  url: CANONICAL_DOMAIN,
  priceRange: "$$",
  currenciesAccepted: "USD",
  paymentAccepted: "Cash, Credit Card, Check",
  address: {
    "@type": "PostalAddress",
    streetAddress: "130 N Preston Rd",
    addressLocality: "Prosper",
    addressRegion: "TX",
    postalCode: "75078",
    addressCountry: "US",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 33.2362,
    longitude: -96.8011,
  },
  hasMap:
    "https://www.google.com/maps/search/?api=1&query=Prosper+Garage+Door+Repair+130+N+Preston+Rd+Prosper+TX+75078",
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00",
    closes: "23:59",
  },
};

export const KEYWORD_PHRASES = [
  "garage door repair near me", "emergency garage door repair", "broken garage spring",
  "garage door won't close", "garage door cable off", "garage door off track",
  "garage door opener repair", "garage door spring replacement", "garage door roller replacement",
  "garage door remote programming", "garage door panel repair",
];

const SERVICES_OFFERED = [
  "Garage Door Broken Spring Repair", "Garage Door Opener Repair & Install", "Off-Track Garage Door Repair",
  "Garage Door Panel Replacement", "New Garage Door Installation", "24/7 Emergency Garage Door Repair",
  "Garage Door Won't Close Repair", "Garage Door Cable Repair & Replacement", "Garage Door Roller Replacement",
  "Garage Door Remote & Keypad Programming",
];

const offerList = SERVICES_OFFERED.map((s) => ({
  "@type": "Offer",
  itemOffered: { "@type": "Service", name: s },
}));

export const localBusinessSchema = (areaServed) => ({
  "@context": "https://schema.org",
  ...ORG,
  "@id": `${CANONICAL_DOMAIN}#business`,
  sameAs: VERIFIED_SOCIALS.map((s) => s.url),
  keywords: KEYWORD_PHRASES.join(", "),
  makesOffer: offerList,
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Garage Door Services",
    itemListElement: offerList,
  },
  areaServed: areaServed || [
    "Prosper", "Celina", "Frisco", "Aubrey", "McKinney", "Melissa", "Anna", "Collin County",
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: REVIEW_RATING,
    reviewCount: String(TESTIMONIALS.length),
  },
  review: TESTIMONIALS.map((t) => ({
    "@type": "Review",
    reviewRating: { "@type": "Rating", ratingValue: String(t.rating), bestRating: "5" },
    author: { "@type": "Person", name: t.name },
    reviewBody: t.text,
  })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const serviceSchema = (cityName, serviceName) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: serviceName || "Garage Door Repair",
  provider: ORG,
  areaServed: { "@type": "City", name: cityName },
  name: serviceName ? `${serviceName} in ${cityName}, TX` : `Garage Door Repair in ${cityName}, TX`,
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${CANONICAL_DOMAIN}${it.path}`,
  })),
});

export const blogPostSchema = (post, image) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: post.title,
  description: post.metaDesc,
  image: image || `${CANONICAL_DOMAIN}/og-image.jpg`,
  datePublished: post.date,
  dateModified: post.date,
  author: { "@type": "Organization", name: BUSINESS.name },
  publisher: ORG,
  mainEntityOfPage: `${CANONICAL_DOMAIN}/garage-door-tips/${post.slug}`,
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: BUSINESS.name,
  url: CANONICAL_DOMAIN,
  publisher: { "@id": `${CANONICAL_DOMAIN}#business` },
});
